export default __webpack_public_path__ + "static/media/WeAreMCSW.7a609180.png";